import { CreateScorecardRowRequest, ScorecardDataItem } from 'api/scorecard';
import { FormState } from '../types';

export const mapFormStateToSimplifiedApiRequest = (formState: FormState, siteId: number): CreateScorecardRowRequest => {
    const {
        category,
        kpi,
        types,
        subtypes,
        treatmentMethod,
        class: kpiClass,
        description,
        includeCostData,
        defaultCurrency,
        defaultUnit
    } = formState;

    // Base request object
    const request: CreateScorecardRowRequest = {
        category,
        kpi: category === 'Waste' ? null : (kpi || null),
        siteId,
        defaultUnit,
        defaultCurrency: includeCostData ? (defaultCurrency || null) : null,
        includeCostData,
        description: description || null
    };

    // Add waste-specific fields only for Waste category
    if (category === 'Waste') {
        request.type = types || null;
        request.subType = subtypes || null;
        request.kpiClass = kpiClass || null;
        request.treatmentMethod = treatmentMethod || null;
    }

    return request;
};

export const mapRowDataToFormState = (rowData: ScorecardDataItem): FormState => ({
    category: rowData.categoryName || '',
    kpi: rowData.kpiName || '',
    types: rowData.kpiType || '',
    subtypes: rowData.kpiSubType || '',
    treatmentMethod: rowData.treatmentMethod || '',
    class: rowData.kpiClass || '',
    defaultUnit: rowData.defaultUnit || '',
    description: rowData.kpiDescription || '',
    includeCostData: rowData.includeCostData || false,
    defaultCurrency: rowData.defaultCurrency || 'USD'
});

/**
 * Checks if any row values are defined (have scorecardDataId not null)
 * @param rowData - The scorecard row data
 * @returns true if any value is defined, false otherwise
 */
export const hasDefinedRowValues = (rowData: ScorecardDataItem | null): boolean => {
    if (!rowData) return false;

    // Check if any value in the values array has scorecardDataId not null
    return rowData.values.some(value => value.scorecardDataId !== null);
};